import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
  const { user, bootstrapped } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (!bootstrapped) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center text-neutral-400 font-mono-tech text-xs uppercase tracking-widest">
        Chargement…
      </div>
    );
  }
  if (!user || user === false) {
    return <Navigate to="/connexion" state={navState} replace />;
  }
  if (requireRole && user.role !== requireRole) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/espace-client"} replace />;
  }
  return children;
}
